import { AlertTriangle } from "lucide-react";
import { URGENT_SIGNS } from "@/data/copy";

export const UrgentCareBox = ({ className = "" }) => (
  <aside
    data-testid="urgent-care-box"
    aria-labelledby="urgent-care-title"
    className={`rounded-3xl border border-red-200 bg-red-50 p-6 md:p-8 ${className}`}
  >
    <div className="flex items-start gap-4">
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-red-700 text-white">
        <AlertTriangle className="h-5 w-5" aria-hidden="true" />
      </span>
      <div>
        <h2 id="urgent-care-title" className="text-xl font-bold text-red-900">Seek urgent medical care</h2>
        <p className="mt-1 text-base text-red-900">
          Go to the nearest emergency department straight away if you have back pain with any of these:
        </p>
        <ul className="mt-4 grid gap-2 sm:grid-cols-2">
          {URGENT_SIGNS.map((s) => (
            <li key={s} className="flex items-start gap-2 text-base text-red-900">
              <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-red-700" aria-hidden="true" />
              {s}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </aside>
);
